export const validateRefpassSchema = json => {
    return true;
};
